import { AccountPurchase } from '../models/account-purchase';

type Customer = Pick<AccountPurchase, 'customerAccount' | 'deliveryAddress'>;

/**
 * A customer of the inquiry by its name and the title of its delivery
 * address. Two cards of the same member differed by street and city alone
 * (R-221).
 */
export const customerLabel = (purchase?: Customer): string | undefined =>
    [purchase?.customerAccount?.name, purchase?.deliveryAddress?.title].filter(Boolean).join(' · ') || undefined;

/**
 * The short name in the bar of customers: the address title where the same
 * member comes more than once — the cut-off name read the same in both
 * chips — and the name everywhere else.
 */
export const customerChipLabel = (purchase: Customer, all: Customer[]): string | undefined => {
    const memberId = purchase.customerAccount?.id;
    const repeated = undefined !== memberId && all.filter(other => other.customerAccount?.id === memberId).length > 1;
    const address = purchase.deliveryAddress;

    return repeated
        ? address?.title ||
              [address?.street, address?.city].filter(Boolean).join(', ') ||
              purchase.customerAccount?.name
        : purchase.customerAccount?.name;
};
